import { bulk as bulkSelections } from '../../selections/actions/update';
import addError from '../../../utils/error.jsx';

export function request(eventId, marketId, participants) {
    return {
        type: 'MARKETS_ADD_ALL_SELECTIONS_REQUEST',
        eventId,
        marketId,
        participants
    };
}

export function error(marketId, errors) {
    addError(errors);

    return {
        type: 'MARKETS_ADD_ALL_SELECTIONS_ERROR',
        errors,
        marketId
    };
}

export function finish(marketId, selections) {
    return (dispatch) => {
        dispatch(bulkSelections(selections));

        selections = selections.map(x => x.id);

        dispatch({
            type: 'MARKETS_ADD_ALL_SELECTIONS_FINISH',
            selections,
            marketId
        });
    };
}
